import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import Breadcrumb from '../admin/Breadcrumb';
import { Toaster } from 'react-hot-toast';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Toaster position="top-right" />
      
      <AdminSidebar 
        user={user} 
        onLogout={handleLogout} 
        isOpen={isSidebarOpen} 
      />

      {/* Main Content */}
      <div className="flex-1">
        <AdminHeader 
          onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} 
          user={user} 
          onLogout={handleLogout} 
        />

        <main className="p-8">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb />
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout; 